import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";



export const login = async (logindata) => {
    try {
        const axiosRes = await axios({
          method: "POST",
          url: `${API_BASE_URL}/api/users/login`,
          data: logindata,
        });
        console.log("login [SUCCESS]",axiosRes.data);
        return axiosRes?.data;
    } catch (err) {
        console.log("login [ERROR]", err);
        return err;
    }
}

export const register = async (signupData) => {
    try {
        const axiosRes = await axios({
          method: "POST",
          url: `${API_BASE_URL}/api/users/signup`,
          data: signupData,
        });
        console.log("register [SUCCESS]",axiosRes.data);
        return axiosRes?.data;
    } catch (err) {
        console.log("login [ERROR]", err);
        return err;
    }
}



export const logout = async () => {
    try {
        localStorage.removeItem('token');
    } catch (err) {
        console.log("logout [ERROR]", err)
    }
}